// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"8518ba66","259":"be5d2d80","558":"54ff79e8","672":"f81e9007","708":"f9599d12"}[chunkId] + ".chunk.js";
};